import React from "react";
import CompetitionCard from "./CompetitionCard";
import CompetitionAd from "./CompetitionAd";
import Button from "../common/Button";
import CardIcon from "../../assets/logo.svg"

const competitionsData = {
  practices: [
    {
      id: 1,
      title: "HPE Codewars Practice Arena",
      hostedBy: "STEAM Minds",
      endsIn: "241 days, 5hrs, 5 min",
      teamSize: "1 Member",
      grade: "1-12",
      icon: CardIcon,
    },
    {
      id: 2,
      title: "HPE Codewars Practice Arena",
      hostedBy: "STEAM Minds",
      endsIn: "241 days, 5hrs, 5 min",
      teamSize: "1 Member",
      grade: "1-12",
      icon: CardIcon,
    },
  ],
  completed: [
    {
      id: 3,
      title: "HPE Codewars Practice Arena",
      hostedBy: "STEAM Minds",
      endsIn: "03:30 PM, PST 13 April, 2025",
      teamSize: "1 Member",
      grade: "1-12",
      prize: "PKR 100,000",
      icon: CardIcon,
    },
    {
      id: 4,
      title: "HPE Codewars Practice Arena",
      hostedBy: "STEAM Minds",
      endsIn: "03:30 PM, PST 13 April, 2025",
      teamSize: "1 Member",
      grade: "1-12",
      prize: "PKR 100,000",
      icon: CardIcon,
    },
    {
      id: 5,
      title: "HPE Codewars Practice Arena",
      hostedBy: "STEAM Minds",
      endsIn: "03:30 PM, PST 13 April, 2025",
      teamSize: "1 Member",
      grade: "1-12",
      prize: "PKR 100,000",
      icon: CardIcon,
    },
  ],
};

const CompetitionsList = ({ activeTab, setActiveTab }) => {
  const competitions =
    activeTab === "practices"
      ? competitionsData.practices
      : competitionsData.completed;

  const handleClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="bg-[#F5F5F5]">
      <div className="max-w-[1665px] mx-auto">
        <div className="flex gap-8 mb-8">
          <Button
            btnText="Practices"
            btnClassName={`font-bold py-2.5 px-5 py- text-xl leading-[23px] rounded-full ${
              activeTab === "practices"
                ? "bg-[#FF6636] text-white"
                : " text-black"
            }`}
            onClick={() => handleClick("practices")}
          />

          <Button
            btnText="Completed"
            btnClassName={`font-bold py-2.5 px-5 py- text-xl leading-[23px] rounded-full ${
              activeTab === "completed"
                ? "bg-[#FF6636] text-white"
                : " text-black"
            }`}
            onClick={() => handleClick("completed")}
          />
        </div>

        <div className="flex gap-[26px]">
          <div className="max-w-[1105px] w-full">
            {competitions.map((competition) => (
              <CompetitionCard
                key={competition.id}
                competition={competition}
                isCompleted={activeTab === "completed"}
              />
            ))}
          </div>
          <div className="flex-1">
            <CompetitionAd />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompetitionsList;
